import {Check} from "@sparkware/app-utils";
import {observer} from "mobx-react";
import {Button} from "../../../../../../basic-ui-components/button/base/button.component";
import {useServices} from "../../../../../../react-hooks/use-services.hook";
import {GameInfo} from "../../../../../../services/games/game-info";
import {GameJackpotComponent} from "../../../../../game-jackpot/game-jackpot.component";
import {VideoListJackpotContainerBox} from "../../../../../live-streaming-tile/static-video-specific-components/video-list-jackpot-container/video-list-jackpot-container.box";
import {VideoListJackpotValueBox} from "../../../../../live-streaming-tile/static-video-specific-components/video-list-jackpot-value/video-list-jackpot-value.box";
import {VideoTileBettingRangeBox} from "../../../../../live-streaming-tile/video-common-components/video-tile-betting-range/video-tile-betting-range.box";
import {VideoSlideFooterBox} from "./boxes/video-slide-footer.box";
import {VideoSlideGameDetailsBox} from "./boxes/video-slide-game-details/video-slide-game-details.box";
import {VideoSlideGameTitleBox} from "./boxes/video-slide-game-title/video-slide-game-title.box";

export type VideoSlideFooterType = "jackpot" | "bets";

interface VideoSlideFooterProps {
    gameInfo: GameInfo;
    type: VideoSlideFooterType;
}
export const VideoSlideFooterComponent: React.FC<VideoSlideFooterProps> = observer((props) => {
    const services = useServices();
    const tableInfo = services.liveTableFeeds.getTableInfo(props.gameInfo.gameType);
    const _renderGameTitle = () => {

        let title = props.gameInfo?.title || "\xa0";

        if (tableInfo?.Name?.length > 0) {
            title = tableInfo.Name;
        }

        return (
            <VideoSlideGameTitleBox>
                {title}
            </VideoSlideGameTitleBox>
        );
    }

    const _renderSecondaryText = () => {
        switch (props.type) {
            case "bets":
                return _renderMinMaxBet();
            case "jackpot":
                return _renderJackpot();
            default:
                return null;
        }
    }


    const _renderMinMaxBet = () => {
        let minBet: number;
        let maxBet: number;

        if (Check.isNullOrUndefined(tableInfo?.MinBet) || Check.isNullOrUndefined(tableInfo?.MaxBet)) {
            minBet = props.gameInfo.minBet;
            maxBet = props.gameInfo.maxBet;
        } else {
            minBet = tableInfo.MinBet;
            maxBet = tableInfo.MaxBet;
        }

        return (
            <VideoTileBettingRangeBox>
                {services.currency.formatMinMaxBet(minBet, maxBet)}
            </VideoTileBettingRangeBox>
        );
    }

    const _renderJackpot = () => {
        if (!props.gameInfo.hasJackpot) {
            return null;
        }

        return (
            <VideoListJackpotContainerBox>
                <span>
                    {services.translation.translate("JACKPOT")}
                </span>
                <VideoListJackpotValueBox>
                    <GameJackpotComponent gameType={props.gameInfo.gameType} />
                </VideoListJackpotValueBox>
            </VideoListJackpotContainerBox>
        );
    }

    return (
        <VideoSlideFooterBox>
            <VideoSlideGameTitleBox>
                {_renderGameTitle()}
                <VideoSlideGameDetailsBox>
                    {_renderSecondaryText()}
                </VideoSlideGameDetailsBox>
            </VideoSlideGameTitleBox>
            <Button
                preset="primary"
                sizeVariant="xs"
                onClick={() => {props.gameInfo.open({isRealMode: true})}}
            >
                {services.translation.translate("PLAY_NOW")}
            </Button>

        </VideoSlideFooterBox>)
})